const _throttle = require('lodash.throttle');

let resizeListenerAdded = false;

function initializeDynamicColumns() {
    // Support both v4 data-dynamic-column and v5 data-faq-column selectors
    const dynamicColumnPanels = document.querySelectorAll('.faq-panel.grid,.people-panel.grid,.accordion-panel.grid');

    dynamicColumnPanels.forEach(dynamicColumnPanel => {
        const dynamicColumns = {
            1: dynamicColumnPanel.querySelector('[data-dynamic-column="1"],[data-faq-column="1"]'),
            2: dynamicColumnPanel.querySelector('[data-dynamic-column="2"],[data-faq-column="2"]'),
            3: dynamicColumnPanel.querySelector('[data-dynamic-column="3"],[data-faq-column="3"]'),
            4: dynamicColumnPanel.querySelector('[data-dynamic-column="4"],[data-faq-column="4"]')
        };

        // Build an ordered array of present columns. Pages with single-column
        // FAQ layouts only render column 1, so without this guard the wider
        // viewport branches below would call appendChild on null.
        const presentColumns = [1, 2, 3, 4]
            .map(n => dynamicColumns[n])
            .filter(Boolean);
        if (!presentColumns.length) return;

        function distributeDynamicCards() {
            const dynamicCards = Array.from(dynamicColumnPanel.querySelectorAll('[data-dynamic-card-index],[data-faq-card-index]'));

            // Sort cards by index
            dynamicCards.sort((a, b) => {
                const aIndex = parseInt(a.dataset.dynamicCardIndex ?? a.dataset.faqCardIndex ?? 0);
                const bIndex = parseInt(b.dataset.dynamicCardIndex ?? b.dataset.faqCardIndex ?? 0);
                return aIndex - bIndex;
            });

            // Distribute cards based on media queries — capped by what's actually rendered.
            const windowWidth = window.innerWidth;
            const targetColumns =
                windowWidth < 640 ? 1 :
                windowWidth < 1024 ? 2 :
                windowWidth < 1280 ? 3 : 4;
            const colCount = Math.min(targetColumns, presentColumns.length);

            dynamicCards.forEach((card, index) => {
                presentColumns[index % colCount].appendChild(card);
            });
        }

        const throttledDistribute = _throttle(distributeDynamicCards, 200);

        // Add resize listener only once
        if (!resizeListenerAdded) {
            window.addEventListener('resize', () => {
                const windowWidth = window.innerWidth;

                if ((windowWidth < 640 && window.prevWidth >= 640) ||
                    (windowWidth >= 640 && windowWidth < 1024 && (window.prevWidth < 640 || window.prevWidth >= 1024)) ||
                    (windowWidth >= 1024 && windowWidth < 1280 && (window.prevWidth < 1024 || window.prevWidth >= 1280)) ||
                    (windowWidth >= 1280 && window.prevWidth < 1280)) {
                    throttledDistribute();
                }
                window.prevWidth = windowWidth;
            });
            resizeListenerAdded = true;
        }

        // Initial distribution
        distributeDynamicCards();
    });
}

// Run on both DOMContentLoaded and window load
document.addEventListener('DOMContentLoaded', initializeDynamicColumns);
window.addEventListener('load', initializeDynamicColumns);
